import React, { Component, Fragment } from "react";
import { Col, Checkbox, Row, Select, Form, Input, Alert } from "antd";
import { observer, inject } from "mobx-react";
import KeyCaptcha from "./KeyCaptcha";
import UsernamePasswordCaptcha from "./UsernamePasswordCaptcha";
import RemoteOCR from "./RemoteOCR";
import styles from "../index.module.less";

const Option = Select.Option;
const FormItem = Form.Item;

const CaptchaProviders = [
	{ value: "ZeroCaptcha", name: "0captcha - Recommended"},
	{ value: "TwoCaptcha", name: "2captcha" },
	{ value: "DeathByCaptcha", name: "DeathByCaptcha - Not Recommended" },
	{ value: "ImageTypers", name: "ImageTypers - Not Recommended" },
	{ value: "AntiCaptcha", name: "AntiCaptcha - Not Recommended" },
	{ value: "RemoteOCR", name: "RemoteOCR" }
];

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class CaptchaForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	createPrimaryCaptchaInfo = disabled => {
		const primaryCaptchaService = this.props.form.getFieldValue(
			"primaryCaptchaService"
		);
		switch (primaryCaptchaService) {
			case "ZeroCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="primaryZeroCaptchaInfo"
						keyField="primaryZeroCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
			case "TwoCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="primaryTwoCaptchaInfo"
						keyField="primaryTwoCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
			case "DeathByCaptcha":
				return (
					<UsernamePasswordCaptcha
						form={this.props.form}
						key="primaryDeathByCaptchaInfo"
						usernameField="primaryDeathByCaptchaInfo.username"
						passwordField="primaryDeathByCaptchaInfo.password"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
			case "ImageTypers":
				return (
					<UsernamePasswordCaptcha
						form={this.props.form}
						key="primaryImageTypersInfo"
						usernameField="primaryImageTypersInfo.username"
						passwordField="primaryImageTypersInfo.password"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
			case "AntiCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="primaryAntiCaptchaInfo"
						keyField="primaryAntiCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
			case "Decaptcher":
				return (
					<UsernamePasswordCaptcha
						form={this.props.form}
						key="primaryDecaptcherInfo"
						usernameField="primaryDecaptcherInfo.username"
						passwordField="primaryDecaptcherInfo.password"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
			case "BeatCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="primaryBeatCaptchaInfo"
						keyField="primaryBeatCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
			case "BypassCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="primaryBypassCaptchaInfo"
						keyField="primaryBypassCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
			case "RemoteOCR":
				return (
					<RemoteOCR
						form={this.props.form}
						key="primaryRemoteOCRInfo"
						addressField="primaryRemoteOCRInfo.address"
						keyField="primaryRemoteOCRInfo.key"
						disabled={disabled}
						provider={primaryCaptchaService}
					/>
				);
		}
		return <div />;
	};

	createSecondaryCaptchaInfo = disabled => {
		const secondaryCaptchaService = this.props.form.getFieldValue(
			"secondaryCaptchaService"
		);
		switch (secondaryCaptchaService) {
			case "ZeroCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="secondaryZeroCaptchaInfo"
						keyField="secondaryZeroCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);			
			case "TwoCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="secondaryTwoCaptchaInfo"
						keyField="secondaryTwoCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);
			case "DeathByCaptcha":
				return (
					<UsernamePasswordCaptcha
						form={this.props.form}
						key="secondaryDeathByCaptchaInfo"
						usernameField="secondaryDeathByCaptchaInfo.username"
						passwordField="secondaryDeathByCaptchaInfo.password"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);
			case "ImageTypers":
				return (
					<UsernamePasswordCaptcha
						form={this.props.form}
						key="secondaryImageTypersInfo"
						usernameField="secondaryImageTypersInfo.username"
						passwordField="secondaryImageTypersInfo.password"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);
			case "AntiCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="secondaryAntiCaptchaInfo"
						keyField="secondaryAntiCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);
			case "Decaptcher":
				return (
					<UsernamePasswordCaptcha
						form={this.props.form}
						key="secondaryDecaptcherInfo"
						usernameField="secondaryDecaptcherInfo.username"
						passwordField="secondaryDecaptcherInfo.password"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);
			case "BeatCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="secondaryBeatCaptchaInfo"
						keyField="secondaryBeatCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);
			case "BypassCaptcha":
				return (
					<KeyCaptcha
						form={this.props.form}
						key="secondaryBypassCaptchaInfo"
						keyField="secondaryBypassCaptchaInfo.captchaKey"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);
			case "RemoteOCR":
				return (
					<RemoteOCR
						form={this.props.form}
						key="secondaryRemoteOCRInfo"
						addressField="secondaryRemoteOCRInfo.address"
						keyField="secondaryRemoteOCRInfo.key"
						disabled={disabled}
						provider={secondaryCaptchaService}
					/>
				);				
		}
		return <div />;
	};

	render() {
		let primaryCaptchaDisabled = !this.props.form.getFieldValue(
			"autoSolveCaptcha"
		);

		let primaryCaptchaInfoSection = "";
		if (!primaryCaptchaDisabled) {
			primaryCaptchaInfoSection = this.createPrimaryCaptchaInfo(
				primaryCaptchaDisabled
			);
		}

		let secondaryCaptchaDisabled = !this.props.form.getFieldValue(
			"useSecondaryCaptchaService"
		);

		let secondaryCaptchaInfoSection = "";

		if (!primaryCaptchaDisabled && !secondaryCaptchaDisabled) {
			secondaryCaptchaInfoSection = this.createSecondaryCaptchaInfo(
				secondaryCaptchaDisabled
			);
		}

		// let checkPrimaryCaptchaBalanceSection = (
		// 	<Fragment>
		// 		<FormItem>
		// 			<Button type="primary">Check Balance</Button>
		// 		</FormItem>
		// 		<b>Balance:</b> 123
		// 	</Fragment>
		// );

		// let checkSecondaryCaptchaBalanceSection = (
		// 	<Fragment>
		// 		<FormItem>
		// 			<Button type="primary">Check Balance</Button>
		// 		</FormItem>
		// 		<b>Balance:</b> 123
		// 	</Fragment>
		// );
		
		let captchaRecommended = <>
			<h1>We recommend using <a href="https://0captcha.com" target="_blank">0captcha</a>, which we cooperate with our partner to develop. <b>0captcha</b> is faster, more accurate and <b>3 times cheaper</b> than other captcha services.</h1>			
			<h1><a href="https://0captcha.com/#comparision" target="_blank">Read more here</a></h1>
		</>;

		return (
			<Fragment>
				<Row style={{ marginBottom: 30 }}>
				<Alert message={captchaRecommended} type="success" />
				</Row>
				<Row gutter={24}>
					<Col span={12}>
						<h3>Primary</h3>
						<Form className={styles.rxform} layout="vertical">
							<FormItem>
								{this.props.form.getFieldDecorator("autoSolveCaptcha", {
									valuePropName: "checked"
								})(<Checkbox>Enable Captcha Solving</Checkbox>)}
							</FormItem>
							<FormItem>
								{this.props.form.getFieldDecorator("primaryCaptchaService")(
									<Select
										placeholder="Select captcha service"
										style={{ width: 300 }}
										disabled={primaryCaptchaDisabled}
									>
										{CaptchaProviders.map(function(provider) {
											if (window.ubUBub == true) {
												if (provider.value == "RemoteOCR") {
													return null;
												}
											}
											return (
												<Option key={provider.value} value={provider.value}>
													{provider.name}
												</Option>
											);
										})}
									</Select>
								)}
							</FormItem>
							{primaryCaptchaInfoSection}
							{/* {primaryCaptchaDisabled ? "" : checkPrimaryCaptchaBalanceSection} */}
						</Form>
					</Col>
					{!primaryCaptchaDisabled ? (
						<Col span={12}>
							<h3>Backup</h3>
							<Form className={styles.rxform} layout="vertical">
								<FormItem>
									{this.props.form.getFieldDecorator(
										"useSecondaryCaptchaService",
										{
											valuePropName: "checked"
										}
									)(<Checkbox>Enable Backup Captcha Service</Checkbox>)}
								</FormItem>
								<FormItem>
									{this.props.form.getFieldDecorator("secondaryCaptchaService")(
										<Select
											placeholder="Select captcha service"
											style={{ width: 200 }}
											disabled={secondaryCaptchaDisabled}
										>
											{CaptchaProviders.map(function(provider) {
												if (window.ubUBub == true) {
													if (provider.value == "RemoteOCR") {
														return null;
													}
												}												
												return (
													<Option key={provider.value} value={provider.value}>
														{provider.name}
													</Option>
												);
											})}
										</Select>
									)}
								</FormItem>
								{secondaryCaptchaInfoSection}
								{/* {secondaryCaptchaDisabled
									? ""
									: checkSecondaryCaptchaBalanceSection} */}
							</Form>
						</Col>
					) : (
						""
					)}
				</Row>
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class CaptchaTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		optionsStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		let options = optionsStore.stateForm;
		return {
			autoSolveCaptcha: Form.createFormField(options.autoSolveCaptcha),
			primaryCaptchaService: Form.createFormField(
				options.primaryCaptchaService
			),
			primaryZeroCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.primaryZeroCaptchaInfo.captchaKey
				)
			},			
			primaryTwoCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.primaryTwoCaptchaInfo.captchaKey
				)
			},
			primaryDeathByCaptchaInfo: {
				username: Form.createFormField(
					options.primaryDeathByCaptchaInfo.username
				),
				password: Form.createFormField(
					options.primaryDeathByCaptchaInfo.password
				)
			},
			primaryImageTypersInfo: {
				username: Form.createFormField(options.primaryImageTypersInfo.username),
				password: Form.createFormField(options.primaryImageTypersInfo.password)
			},
			primaryAntiCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.primaryAntiCaptchaInfo.captchaKey
				)
			},
			primaryDecaptcherInfo: {
				username: Form.createFormField(options.primaryDecaptcherInfo.username),
				password: Form.createFormField(options.primaryDecaptcherInfo.password)
			},
			primaryBeatCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.primaryBeatCaptchaInfo.captchaKey
				)
			},
			primaryBypassCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.primaryBypassCaptchaInfo.captchaKey
				)
			},
			primaryRemoteOCRInfo: {
				address: Form.createFormField(options.primaryRemoteOCRInfo.address),
				key: Form.createFormField(options.primaryRemoteOCRInfo.key)
			},
			useSecondaryCaptchaService: Form.createFormField(
				options.useSecondaryCaptchaService
			),
			secondaryCaptchaService: Form.createFormField(
				options.secondaryCaptchaService
			),
			secondaryZeroCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.secondaryZeroCaptchaInfo.captchaKey
				)
			},
			secondaryTwoCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.secondaryTwoCaptchaInfo.captchaKey
				)
			},
			secondaryDeathByCaptchaInfo: {
				username: Form.createFormField(
					options.secondaryDeathByCaptchaInfo.username
				),
				password: Form.createFormField(
					options.secondaryDeathByCaptchaInfo.password
				)
			},
			secondaryImageTypersInfo: {
				username: Form.createFormField(
					options.secondaryImageTypersInfo.username
				),
				password: Form.createFormField(
					options.secondaryImageTypersInfo.password
				)
			},
			secondaryAntiCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.secondaryAntiCaptchaInfo.captchaKey
				)
			},
			secondaryDecaptcherInfo: {
				username: Form.createFormField(
					options.secondaryDecaptcherInfo.username
				),
				password: Form.createFormField(options.secondaryDecaptcherInfo.password)
			},
			secondaryBeatCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.secondaryBeatCaptchaInfo.username
				)
			},
			secondaryBypassCaptchaInfo: {
				captchaKey: Form.createFormField(
					options.secondaryBypassCaptchaInfo.captchaKey
				)
			},
			secondaryRemoteOCRInfo: {
				address: Form.createFormField(options.secondaryRemoteOCRInfo.address),
				key: Form.createFormField(options.secondaryRemoteOCRInfo.key)
			}
		};
	};
	render() {
		return (
			<CaptchaForm
				onFieldsChange={this.onFieldsChange}
				fields={this.mapPropsToFields()}
				wrappedComponentRef={internalForm => {
					this.internalForm = internalForm;
				}}
			/>
		);
	}
}

export default CaptchaTab;
